/* eslint-disable no-else-return */
import { useEffect, useLayoutEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import Login from "../../pages/Auth/Login";
import { loadUser } from "../../store/features/Auth/AuthApi";
import { RootStore, useAppDispatch, useAppSelector } from "../../store/store";
import { ROUTES } from "../../helpers/utils/Constants/route";
import { Domain } from "../../helpers/utils/DomainSwitcher/domains";
import { roles } from "../../helpers/utils/Constants/roles";
import { isSelfPacedStudentWithTAA } from "../../helpers/utils/roleUtils";

const MentorRoute = ({ children }: { children: JSX.Element }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [admin, setAdmin] = useState(false);
  const [authFail, setAuthFail] = useState(false);
  const dispatch = useAppDispatch();
  const authState: any = useAppSelector((store: RootStore) => {
    return store.AuthSlice;
  });
  const configState: any = useAppSelector((store: RootStore) => {
    return store.ThemeSlice;
  });
  useLayoutEffect(() => {
    dispatch(loadUser({ setAuthFail: setAuthFail }));
  }, []);
  useEffect(() => {
    if (authFail) {
      navigate("/");
    }
  }, [authFail]);

  useLayoutEffect(() => {
    if (authState.authenticated && authState.tac_user) {
      if (!authState.tac_user.default_password_updated) {
        navigate("/default-password-change");
      }
      if (
        authState.tac_user.role === "user" &&
        configState.configs.membership_enabled === Domain.TAA
      ) {
        navigate(ROUTES.ACADEMIC_USER_DASHBOARD);
      }
            if (
         isSelfPacedStudentWithTAA(authState, configState)
        ) {
          // navigate(ROUTES.SELF_PACED_USER_DASHBOARD);
           navigate(ROUTES.ACADEMIC_USER_DASHBOARD);
          // return
        }
      if (
        authState.tac_user.role === "user" &&
        configState.configs.membership_enabled === Domain.TAC
      ) {
        navigate(ROUTES.PROGRESS);
      }
      if (authState.tac_user.role === "owner") {
        navigate("/organization");
      }
      if (authState.tac_user.role === "admin") {
        navigate("/organization");
      }
      if (authState.tac_user.role === "sys_adm") {
        navigate("/dashboard");
      }

      if (authState.tac_user.role === "mentor") {
        setAdmin(true);
      }
    }
  }, [authState.authenticated]);

  if (admin) {
    return children;
  } else {
    return null;
  }
};

export default MentorRoute;
